exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sidebar[data-v-6c5cc5f4]{\n  position: fixed;\n  top: 64px !important;\n  z-index: 11;\n  height: calc(100% - 64px) !important;\n}\n.sidebar-list[data-v-6c5cc5f4]{\n  padding-top: 0px;\n}\n.list-item[data-v-6c5cc5f4]{\n  height: 80px !important;\n}\n.selected[data-v-6c5cc5f4]{\n  background-color: rgb(255, 255, 255, 0.3);\n  border-width: 0px 0px 0px 3px;\n  border-color: white;\n  border-style: solid;\n  padding-left: -3px;\n}\n.link-icon[data-v-6c5cc5f4]{\n  padding: 20px;\n  margin: -20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c5cc5f4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NavDrawer.vue
// module id = 19Us
// module chunks = 1